/**
 * Used to configure selector cache for search selectors with parameters
 * 1000 is an arbitrary number, picked to confidently contain multiple pages of hotels with offers (and potentially more offers loaded)
 */
export const SELECTOR_MAX_CACHE_ENTRIES = 1000
